<template>
  <article :class="['alert-component', visible ? 'visible' : '', alert.priority]">
    <h2>{{ alert.title }}</h2>
    <p v-if="alert.description" v-html="alert.description"></p>
    <button class="close" v-on:click="close()">
      <icon name="close"></icon>
    </button>
  </article>
</template>

<script>
import Alert from '@/lib/transfer-objects/Alert'

export default {
  name: 'AlertComponent',
  props: {
    alert: {
      type: Alert,
      required: true
    }
  },
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.visible = true
    }, 100)

    if (this.alert.isEphemeral() === true) {
      setTimeout(() => {
        this.close()
      }, this.alert.duration)
    }
  },
  methods: {
    close: function () {
      this.visible = false
      setTimeout(() => {
        this.$emit('remove', this.alert)
      }, 500)
    }
  }
}
</script>

<style lang="sass">
@import './static/sass/variables.sass'

.alert-component
  display: block
  position: relative
  height: auto
  z-index: 98
  margin: 1rem
  padding: 1rem
  border-radius: 3px
  background: $white
  box-shadow: 0 0 5px rgba($black, .3)
  opacity: 0
  transform: translateY(100px)
  transition: opacity .2s, transform .2s

  &.high
    background-color: $color-high
    color: $white
    .material-icons
      color: $white
  &.medium
    background-color: $color-medium
    color: $white
    .material-icons
      color: $white
  &.low
    background-color: $color-low
  &.good
    background-color: $color-good
    color: $white
    .material-icons
      color: $white

  &.visible
    opacity: 1
    transform: translateY(0)

  h2
    font-size: 1rem
    margin: 0 0 .5rem

  p
    font-size: .75rem
    margin: 0

  .material-icons
    font-size: 1rem

.alert-component .close
  appearance: none
  border: 0
  cursor: pointer
  background: transparent
  position: absolute
  top: 1rem
  right: .5rem
  font-size: 1rem
</style>



// WEBPACK FOOTER //
// src/components/Alert.vue